import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '~Layout';
import List from './List';
import Transactions from './Transactions';
import History from './History';

export default function Router(): ReactElement {
    return (
        <Layout topSection='accounts'>
            <Switch>
                <Route exact={true} path='/prepaid-interest-sale-transfers' component={List} />
                <Route exact={true} path='/prepaid-interest-sale-transfers/:warehouseLoanTransactionAbaUuid/history' component={History} />
                <Route exact={true} path='/prepaid-interest-sale-transfers/:warehouseLoanTransactionAbaUuid/transactions' component={Transactions} />
            </Switch>
        </Layout>
    );
}
